export const THRESHOLD_UNIT = {
  HOURS: "hours",
  DAYS: "days"
};

export const normalizeUnit = (unitType) => String(unitType || "").trim().toLowerCase();

// Every threshold unit other than hours/days is a count unit (shift, block, game, ...).
// An empty unit stays hours.
export const isCountUnit = (unitType) => {
  const unit = normalizeUnit(unitType);
  return unit !== "" && unit !== THRESHOLD_UNIT.HOURS && unit !== THRESHOLD_UNIT.DAYS;
};

export const isCountRateUnit = (rateUnitType) => {
  const unit = normalizeUnit(rateUnitType);
  return unit !== "" && unit !== "hourly" && unit !== "daily";
};

// "weekend shift" -> "Weekend Shift"
export const formatUnitLabel = (unitType) =>
  normalizeUnit(unitType).replace(/\b\w/g, (char) => char.toUpperCase());

// "block" -> "blocks", "weekend shift" -> "weekend shifts"
export const pluralizeUnit = (unitType) => {
  const unit = normalizeUnit(unitType);
  return unit === "" || unit.endsWith("s") ? unit : `${unit}s`;
};
